// Bundle images mapping
const imageUrls = {
  "Joyful Orange": [
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_orange_6_300x300.webp",
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_orange_3_300x300.webp",
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_orange_1_300x300.webp"
  ],
  "Graphite Black": [
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_black_6_300x300.webp",
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_black_3_300x300.webp",
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_black_1_300x300.webp"
  ],
  "Milkshake Pink": [
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_pink_6_300x300.webp",
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_pink_3_300x300.webp",
    "https://cdn.shopify.com/s/files/1/0876/3847/5031/files/journal_bundle_pink_1_300x300.webp"
  ]
};

// Function to update bundle images for each specific option
function updateBundleImages(color) {
  const bundleContainers = document.querySelectorAll(".kaching-bundles__bar-wrapper");

  if (!imageUrls[color]) {
    console.warn("No images mapped for the selected color:", color);
    return;
  }

  bundleContainers.forEach((container, index) => {
    const imgElement = container.querySelector("img.kaching-bundles__bar-image");
    if (!imgElement) return;

    const newImageUrl = imageUrls[color][index];
    if (newImageUrl) {
      imgElement.setAttribute("src", newImageUrl);
    } else {
      console.warn(`No image mapped for option ${index + 1} and color: ${color}`);
    }
  });
}

// Adding event listeners to color swatches
document.querySelectorAll("li.ecom-product-single__swatch-item").forEach((swatch) => {
  swatch.addEventListener("click", () => {
    const selectedColor = swatch.getAttribute("data-value");
    updateBundleImages(selectedColor);
  });
});

// Handling sticky cart dropdown (if present)
const stickyCartDropdown = document.querySelector("#ecom-sticky-cart__select-headway-self-awareness-journal");

if (stickyCartDropdown) {
  stickyCartDropdown.addEventListener("change", () => {
    const selectedOption = stickyCartDropdown.options[stickyCartDropdown.selectedIndex];
    const selectedImage = selectedOption.getAttribute("data-image");
    const selectedText = selectedOption.textContent.trim();

    let selectedColor = null;

    if (selectedImage && selectedImage.includes("Black")) {
      selectedColor = "Graphite Black";
    } else if (selectedImage && selectedImage.includes("Pink")) {
      selectedColor = "Milkshake Pink";
    } else if (selectedImage && selectedImage.includes("Orange")) {
      selectedColor = "Joyful Orange";
    } else if (selectedText.includes("Joyful Orange")) {
      selectedColor = "Joyful Orange";
    }

    if (selectedColor) {
      updateBundleImages(selectedColor);
    } else {
      console.warn("No color mapping found for selected sticky cart color:", selectedText);
    }
  });
}